import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Button } from "@natera/material/lib/button";

import AccountBgImage from "@app/preBill/assets/images/account_bg.png";

import "./accountInfoBox.scss";

const messages = defineMessages({
  accountInfoBoxAccountTitle: {
    id: "accountInfoBoxAccountTitle",
    defaultMessage: "Don’t have an account yet?",
  },
  accountInfoBoxAccountDescription: {
    id: "accountInfoBoxAccountDescription",
    defaultMessage:
      "In Natera’s Patient Portal, you can access your test result and useful resources any time.",
  },
  accountInfoBoxAccountCreateButton: {
    id: "accountInfoBoxAccountCreateButton",
    defaultMessage: "Create account",
  },
});

type AccountInfoBoxProps = {
  createAccountButtonAction: () => Promise<void>;
  isLoading: boolean;
};

const AccountInfoBox: FC<AccountInfoBoxProps> = ({
  createAccountButtonAction,
  isLoading,
}) => {
  const intl = useIntl();

  return (
    <div className="account-info-box">
      <div className="account-info-box__title">
        {intl.formatMessage(messages.accountInfoBoxAccountTitle)}
      </div>
      <div className="account-info-box__description">
        {intl.formatMessage(messages.accountInfoBoxAccountDescription)}
      </div>
      <div className="account-info-box__button">
        <Button
          className="account-info-box__button__create"
          outlined
          onClick={createAccountButtonAction}
          loading={isLoading}
        >
          {intl.formatMessage(messages.accountInfoBoxAccountCreateButton)}
        </Button>
      </div>
      <img
        className="account-info-box__image"
        src={AccountBgImage}
        alt={intl.formatMessage(messages.accountInfoBoxAccountCreateButton)}
      />
    </div>
  );
};

export default AccountInfoBox;
